import Actions from '../../odata/actions';

const actions = new Actions('attachment', 'attachments');

export default actions;
